import { render, staticRenderFns } from "./PositionsUsers.vue?vue&type=template&id=4e8c94e7"
import script from "./PositionsUsers.vue?vue&type=script&lang=js"
export * from "./PositionsUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports